import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { LoadingIndicator } from "../framework/loadingIndicatorNew";
import { SvgIconComponent } from "@mui/icons-material";

interface TextInlineEditProps {
    value: string;
    Icon?: SvgIconComponent;
    handleSave: (newValue: string) => Promise<void>;
}

export const TextInlineEdit = ({
    value,
    Icon,
    handleSave: onSave,
}: TextInlineEditProps) => {
    const [editing, setEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [tempValue, setTempValue] = useState(value);

    useEffect(() => {
        setTempValue(value);
    }, [value]);

    const handleSave = async() => {
        if (tempValue === value) {
            setEditing(false);
            return;
        }

        setLoading(true);
        try {
            await onSave(tempValue);
            setEditing(false);
        } finally {
            setLoading(false);
        }
    };

    if (editing) {
        return (
            <>
                <LoadingIndicator loading={loading} />
                <TextField
                    value={tempValue}
                    onChange={(e) => setTempValue(e.target.value)}
                    onBlur={() => {
                        void handleSave();
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            void handleSave();
                        } else if (e.key === "Escape") {
                            setTempValue(value);
                            setEditing(false);
                        }
                    }}
                    size="small"
                    autoFocus
                    inputProps={{ maxLength: 50 }}
                />
            </>
        );
    }

    return (
        <Typography
            className="hover-effect text-inline-edit-value"
            fontSize="small"
            fontWeight="600"
            onClick={() => setEditing(true)}
            sx={{ cursor: "pointer" }}
        >
            {value && (
                <>
                    {Icon && (
                        <Icon
                            fontSize="small"
                            color="primary"
                            sx={{ mr: 0.5 }}
                        />
                    )}
                    {value}
                </>
            )}
        </Typography>
    );
};
